/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GraphAnnotationModel } from '../../models/graph-annotation-model';

export interface GetGraphAnnotations$Params {
  patientID?: number;
}

export function GetGraphAnnotations(http: HttpClient, rootUrl: string, params?: GetGraphAnnotations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GraphAnnotationModel>>> {
  const rb = new RequestBuilder(rootUrl, GetGraphAnnotations.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GraphAnnotationModel>>;
    })
  );
}

GetGraphAnnotations.PATH = '/api/Graph/GetGraphAnnotations';
